// extracted by mini-css-extract-plugin
module.exports = {"container":"AccreditationDropdownFilter_container__1hQ98","select":"AccreditationDropdownFilter_select__3N0L9"};